import { ref } from 'vue';
import type { Router } from 'vue-router';

const loopPageCounter = ref<number>(0);

/**
 * ページの自己ループ検知に利用
 * handleLoopDetectionは自己ループを確認し、ループしているどうかを返却する
 */
export function useLoopPageCounter() {
  function handleLoopDetection(router: Router | undefined, name: string): boolean {
    const maxLoopCount = 5;

    if (!router) {
      return false;
    }

    if (router.currentRoute.value.name === name) {
      loopPageCounter.value += 1;
    } else {
      loopPageCounter.value = 0;
    }

    return loopPageCounter.value >= maxLoopCount;
  }

  return {
    handleLoopDetection,
  };
}
